import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import HeroPaint from "../components/HeroPaint";
import PC from "../components/PC";
import Brands from "../components/Brands";
import Footer from "../components/Footer";

const PaintCPage = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);
    return (
        <div className="paint">
            <Navbar />
            <HeroPaint />
            <PC />
            <Brands />
            <Footer />
        </div>
    );
};

export default PaintCPage;
